import {
  getLearnerHostFromEnvName,
  getWebsiteHostFromEnvName,
  makeLocalePrefix,
} from "./utils";

export interface RouteInitOptions {
  env?: string;
  websiteHost?: string;
  learnerHost?: string;
  appHostName?: string;
  onError?: (error: Error) => void;
  locale?: string;
}

let gWebsiteHost = "https://outschool.com";
let gLearnerHost = "https://learner.outschool.com";
let gOnError = (_error: Error) => {};
let gInitialized = false;
let locale = "en";

export function init(options: RouteInitOptions = {}) {
  if (gInitialized && options.env !== "test") {
    throw new Error("@outschool/routes is already initialized");
  }

  if (options.env) {
    gWebsiteHost = getWebsiteHostFromEnvName({
      outschoolEnv: options.env,
      appHostName: options.appHostName,
    });
    gLearnerHost = getLearnerHostFromEnvName({
      outschoolEnv: options.env,
      appHostName: options.appHostName,
    });
  }

  if (options.websiteHost) {
    gWebsiteHost = options.websiteHost;
  }

  if (options.learnerHost) {
    gLearnerHost = options.learnerHost;
  }

  if (options.onError) {
    gOnError = options.onError;
  }

  if (options.locale) {
    locale = options.locale;
  }

  gInitialized = true;
}

export function websiteHost() {
  return gWebsiteHost;
}

export function learnerHost() {
  return gLearnerHost;
}

export function onError(error: Error) {
  return gOnError(error);
}

export function pathToUrl(path: string, localeOverride?: string) {
  return `${websiteHost()}${makeLocalePrefix(
    localeOverride ? localeOverride : locale
  )}${path}`;
}

export type PathFn = (...args: any[]) => string;
export function makeUrlFromPathFn<T extends PathFn>(
  fn: T,
  localeOverride?: string
): (...args: Parameters<T>) => string {
  return function (...args: Parameters<T>) {
    return pathToUrl(fn(...args), localeOverride);
  };
}

export function learnerPathToUrl(path: string) {
  return `${learnerHost()}${path}`;
}

export function makeUrlFromLearnerPathFn<T extends PathFn>(
  fn: T
): (...args: Parameters<T>) => string {
  return function (...args: Parameters<T>) {
    return learnerPathToUrl(fn(...args));
  };
}
